export default __webpack_public_path__ + "static/media/mobile_language_options_image_en.a76593fe.png";